<div class="empty-cart-page">
    <div class="container">
        <div class="empty-img"></div>
        <h1>{{ "savedCart.yourCartEmpty" | cxTranslate }}</h1>
        <p>{{ "savedCart.searchOrBrowse" | cxTranslate }}</p>
    </div>    
</div>